import Http from '@/services/Http';

const client = new Http('');

client.getProductPlans = (id) => client.get(id, '', '/plans');

export default client;
